__webpack_require__.p = "/bizx-smart/ir-farm-house/";